var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[(_vm.props.data && _vm.props.data.value)?_c('span',[_vm._v("Internal")]):_c('span',[_vm._v("External")])])}
var staticRenderFns = []

export { render, staticRenderFns }